import { IBenchmarkRange } from './App.types';

export const APP_MARGIN = 14;
export const COLORS_TRANSPARENT = 'transparent';
export const COLORS_WHITE = '#ffffff';
export const COLORS_BLUE = '#00ccff';
export const COLORS_PINK = '#ff91d6';
export const COLORS_GREEN = '#00C87B';
export const COLORS_LIGHTGREEN = '#CCFFE7';
export const COLORS_TEAL = '#ccffff';
export const COLORS_LIGHTGRAY = '#EBF1F4';
export const COLORS_LIGHTGRAYBG = '#F5F8FA';
export const COLORS_COOLGRAY = '#4B505B';
export const COLORS_COOLGRAY60 = '#666B73';
export const COLORS_COOLGRAY20 = '#E4E6EB';
export const COLORS_COOLGRAY30 = '#CED1D9';
export const COLORS_GREEN40 = '#A1F7D2';
export const COLORS_GREEN30 = '#CCFFE7';
export const COLORS_GREEN20 = '#E5FFF3';
export const COLORS_RED = '#e55252';
export const COLORS_GRAY_BORDER = 'rgba(151, 151, 151, 0.5)';

export const BUSINESS_DAYS_PER_YEAR = 261;

export const UN_CAPTURED_REVENUE_LEVEL = 25000;

export const levelZeroSummaryMessage =
  'Looks like you\'ve captured more revenue than is even possible given those numbers?! Did you enter your actual revenue in "Starting Annual Revenue" or your revenue goal?';
export const levelOneSummaryMessage = "Way to go! That's impressive. We'd love to know how you do it! Let's chat.";
export const levelTwoSummaryMessage =
  "Looks like there is a lot of un-captured revenue potential in your business. Wanna learn how to capture more? Let's chat.";

export const revenuePerBillableEmployeeBenchmarks: IBenchmarkRange = {
  low: 104000,
  mid: 215000,
  high: 2910000,
};

export const revenuePerEmployeeBenchmarks: IBenchmarkRange = {
  low: 77000,
  mid: 175000,
  high: 253000,
};

export const targetAverageUtilizationBenchmarks: IBenchmarkRange = {
  low: 60,
  mid: 75,
  high: 85,
};

export const INVALID_EMAIL_PROVIDERS = ['gmail.com', 'hotmail.com', 'yahoo.com', 'msn.com', 'outlook.com', 'apple.com'];

export const HUBKEY = 'HUBSPOT_KEY';
